export default __webpack_public_path__ + "9206786b1bb061cdcba0be8f3854d12b.png";